<template>
	<div class="package-card" :class="{'recommended': product.is_popular}">
		<p class="package-card-header" :class="{'promo': promoPrice || promoPrice === 0}">
			<template v-if="promoPrice || promoPrice === 0">
				<span class="promo">R{{ parseFloat(promoPrice).toLocaleString('en-ZA') }} <sup>pm</sup></span>
				<span class="strike">R{{ parseFloat(originalPrice).toLocaleString('en-ZA') }} <sup>pm</sup></span>
			</template>
			<template v-else>
				R{{ parseFloat(product.price).toLocaleString('en-ZA') }} <sup>pm</sup>
			</template>

		</p>
		<div class="package-card-footer">
			<svg class="icon"><use xlink:href="#speed-down"></use></svg>
			{{ product.speed_down }}Mbps
			<svg class="icon"><use xlink:href="#speed-up"></use></svg>
			{{ product.speed_up }}Mbps
		</div>
	</div><!-- end.package-card -->
</template>

<script>
	export default {
		props: ['providerSlug', 'product'],
		computed: {
			originalPrice() {
				switch (this.product.solution_id) {

					// vuma aerial
					case 1965820: return 727
					case 1966820: return 927
					case 1967820: return 1047
					case 1968820: return 1197
					case 1969820: return 1497
					case 1970820: return 2347

					// vuma
					case 1958820: return 727
					case 1959820: return 927
					case 1960820: return 1047
					case 1961820: return 1197
					case 1963820: return 1497
					case 1962820: return 2347

					default:
						return this.product.price
				}
			},
			promoPrice() {
				switch (this.product.solution_id) {
					//Vodacom
					case 1708820:
						return (parseFloat('497'));
					case 1714820:
						return (parseFloat('997'));
					case 1709820:
						return (parseFloat('597'));
					case 1753820:
						return (parseFloat('647'));
					case 1754820:
						return (parseFloat('697'));
					case 1713820:
						return (parseFloat('897'));
					default:
						return false
				}
			}
		}
	}
</script>
